/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef, use } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import { getUserProfile, loginUser } from "../../slices/userSlice"; // Importamos la acción del slice
import Alert from "../../components/alerts/Alert";
import SuccessAlert from "../../components/alerts/SuccessAlert";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Input from "@mui/material/Input";
import logo from "../../assets/logo.avif";

import ModalForgotPassword from "../../components/modales/login/ModalForgotPassword";

import ModalLoginError from "../../components/modales/login/ModalLoginError";
import ModalLoginSuccess from "../../components/modales/login/ModalLoginSuccess";

const LoginScreen = () => {
  const [username, setUsername] = useState(""); // Estado para el nombre de usuario
  const [password, setPassword] = useState(""); // Estado para la contraseña
  const [captchaMessage, setCaptchaMessage] = useState(false); // Estado para el mensaje de CAPTCHA
  const [showPassword, setShowPassword] = useState(false); // Estado para mostrar/ocultar la contraseña
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { isDarkMode } = useSelector((state) => state.darkMode);
  const [successEmail, setSuccesEmail] = useState(false)
  const [errorEmail, setErrorEmail] = useState(false)

  const location = useLocation()
  console.log(location);
  

  useEffect(() => {
      if (isDarkMode) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    }, [isDarkMode]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Usamos el estado de Redux para obtener el estado de login
  const { loading, error, userInfo } = useSelector((state) => state.user);
  
  
  const [searchParams] = useSearchParams();
  const captcha = useRef(null);

  useEffect(() => {
    dispatch(getUserProfile())
    if (userInfo && userInfo.userType === "Admin") {
      navigate("/admin/prospects");
    }
    if (userInfo && userInfo.userType === "Client") {
      navigate("/client");
    }
  }, [navigate, userInfo]);

  useEffect(() => {

  },[])




  const submitHandler = (e) => {
    e.preventDefault(); // Prevenir el comportamiento por defecto del formulario
    if (process.env.NODE_ENV === "development" || captcha.current.getValue()) {
      // Si el captcha es válido o estamos en desarrollo, hacemos el dispatch de login
      dispatch(loginUser({ username, password, token: captcha.current.getValue() }));
      console.log(username);
      
    } else {
      setCaptchaMessage(true);
    }
  };

  const onChange = () => {
    if (captcha.current.getValue()) {
      setCaptchaMessage(false); 
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword); 
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-sm mx-auto p-8 border border-border bg-background shadow-lg rounded-lg">
        <div className="flex justify-center">
          <img src={logo} alt="" />
        </div>

        <div className="mt-8">
          {error && <Alert title="Login failed" text={error} />}
          {captchaMessage && <Alert title="CAPTCHA invalid" text="Please accept CAPTCHA" />}
          <div className="space-y-6">
            <div>
              <label htmlFor="username" className="block text-sm font-medium text-gray-700">
                Usuario o Email
              </label>
              <div className="mt-1">
                <input
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value.toLowerCase())}
                  name="username"
                  type="text"
                  autoComplete="username"
                  required
                  className="block w-full p-3 rounded-md border text-text border-gray-300 bg-background shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Contraseña
              </label>
              <div className="mt-1">
                <Input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  required
                  className="block w-full p-3 rounded-md border text-text border-gray-300 bg-background shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton onClick={handleClickShowPassword}>
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </div>
              <div className="flex justify-end mt-1 ">
              <p onClick={() => setIsModalOpen(true) } className="text-xs cursor-pointer font-poppina hover:underline text-text "  >Olvide la contraseña</p>
              </div>
            </div>

            <div className="flex justify-center py-4">
              <ReCAPTCHA
                ref={captcha}
                sitekey="6LfbacQqAAAAAJax_3gBX_sL2Rg6rCL_1Bozq3cE"
                onChange={onChange}
              />
            </div>

            <div>
              <button
                onClick={submitHandler}
                type="submit"
                className="w-full py-3 px-4 rounded-md bg-indigo-600 text-white font-medium text-sm shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                Iniciar sesion
              </button>
            </div>
          </div>
        </div>
      </div>

      <ModalLoginSuccess successEmail={successEmail} setSuccesEmail={setSuccesEmail}   />
      <ModalLoginError errorEmail={errorEmail} setErrorEmail={setErrorEmail} />

      <ModalForgotPassword setIsModalOpen={setIsModalOpen} setSuccesEmail={setSuccesEmail} isModalOpen={isModalOpen} setErrorEmail={setErrorEmail} />
    </div>
  );
};

export default LoginScreen;

